import React from 'react'

import { ProductHeader } from '../ProductHeader'

export const PageHeader = () => {
	return (
		<header>
			{/* <div className='vehicle-part-page-header'>

				<div className='vehicle-part-page-header-logo-desktop'>
					<ReactSVG src='/icons/autodiler-logo.svg' wrapper='span' beforeInjection={svg => {
						svg.setAttribute('width', '219px')
						svg.setAttribute('height', '41px')
					}} />
				</div>

				<div className='vehicle-part-page-header-logo-mobile'>
					<ReactSVG src='/icons/logo-mobile.svg' wrapper='span' beforeInjection={svg => {
						svg.setAttribute('width', '200px')
						svg.setAttribute('height', '30px')
					}} />
				</div>

				<div className='vehicle-part-page-header-links'>
					<Link href='/'>
						<a>
							<ReactSVG src='/icons/home.svg' wrapper='span' beforeInjection={svg => {
								svg.setAttribute('width', '20px')
								svg.setAttribute('height', '20px')
							}} />

							<span>
								{t('Početna').toUpperCase()}
							</span>
						</a>
					</Link>

					<Link href='/categories'>
						<a>
							<ReactSVG src='/icons/categories.svg' wrapper='span' beforeInjection={svg => {
								svg.setAttribute('width', '20px')
								svg.setAttribute('height', '20px')
							}} />

							<span>
								{t('Kategorije').toUpperCase()}
							</span>
						</a>
					</Link>
				</div>

				<UserMenuMobile />
			</div> */}

			<ProductHeader />
		</header>
	)
}
